module.exports = ".mat-input-element:disabled {\n  color: rgba(0, 0, 0, 0.87); }\n\n.filter-icon {\n  position: relative;\n  top: 5px;\n  padding-right: 5px; }\n\n.mat-cell-padding {\n  padding-right: 5px; }\n\n.mat-cell-margin {\n  margin-left: 25px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/offers/offer-withdrawn/offer-withdrawn.component.scss
// module id = ./src/app/modules/offers/offer-withdrawn/offer-withdrawn.component.scss
// module chunks = main